export default __webpack_public_path__ + "images/7156877ae5d3275eab1d1a03b3036dbf-ballon.png";